import React from "react";
import "./PdfExportButton.css";

const PdfExportButton = ({
  onClick,
  loading = false,
  disabled = false,
  title = "Download PDF",
  className = "",
  label = "PDF",
  loadingLabel = "Exporting...",
}) => (
  <button
    type="button"
    className={["pdf-export-button", className].filter(Boolean).join(" ")}
    onClick={onClick}
    disabled={disabled || loading}
    title={title}
  >
    <i className="bi bi-file-earmark-pdf" aria-hidden />
    <span>{loading ? loadingLabel : label}</span>
  </button>
);

export default PdfExportButton;
